import { FC } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

export interface IOption {
	title: string;
	value: string;
}

export interface CustomSelectProps {
	options?: IOption[];
	value: string;
	placeholder?: string;
	label?: string;
	onChange: (value: SelectChangeEvent<string>) => void;
	name: string;
	className?: string;
	helperText?: string;
	disableOption?: boolean;
	multiple?: boolean;
}

export const CustomSelect: FC<CustomSelectProps> = ({
	value,
	options,
	className,
	placeholder,
	label,
	onChange,
	name,
	helperText,
	multiple,
}) => {
	const handleRenderSelectValue = (value: string | string[]) => {
		const isValueEmptyArray = Array.isArray(value) && !value.length;
		const isValueEmpty = !Array.isArray(value) && !value;

		if (isValueEmptyArray || isValueEmpty) return placeholder || '';

		const inputValue = options?.reduce((acc, curr) => {
			if (Array.isArray(value)) {
				return value.includes(curr.value) ? `${acc}${curr.title ? `${acc ? ', ' : ''}${curr.title}` : ''}` : acc;
			}
			return value === curr.value ? curr.title : acc;
		}, '');

		return inputValue;
	};
	const labelId = label ? `${name}-label` : undefined;

	return (
		<FormControl className={className} fullWidth>
			{label && (
				<InputLabel id={labelId} shrink>
					{label}
				</InputLabel>
			)}
			<Select
				multiple={multiple}
				displayEmpty
				value={value ?? ''}
				onChange={onChange}
				name={name}
				label={label}
				labelId={labelId}
				renderValue={handleRenderSelectValue}
			>
				<MenuItem style={{ display: 'none' }} disabled value={''}>
					<em>{placeholder || label}</em>
				</MenuItem>
				{options?.map((item) => (
					<MenuItem key={item.value} value={item.value} title={item.title}>
						{item.title}
					</MenuItem>
				))}
			</Select>
			{helperText && <FormHelperText>{helperText}</FormHelperText>}
		</FormControl>
	);
};
